/* eslint-disable flowtype/no-types-missing-file-annotation */
import React, { useState, useEffect, useCallback } from 'react';

import {
    TextInput, Box, Form, FormField, Stack,
} from 'grommet';
import { Search } from 'grommet-icons/es6';
import { debounce } from 'lodash';
import { injectIntl, useIntl } from 'react-intl';
import StyledCloseButtom from '../grommet2/forms/fields/StyledCloseButton';

type Props = {
    onSubmit: e => void,
}

const SearchField = (props: Props) => {
    const { onSubmit } = props;
    const intl = useIntl();
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearch = useCallback(
        debounce((term) => {
            onSubmit(term);
        }, 400),
        [],
    );

    const handleClearSearch = () => {
        setSearchTerm('');
        onSubmit(null);
    };

    useEffect(() => {
        if (searchTerm.length > 3) {
            // Trim the search term as it will break searches for keywords
            handleSearch(searchTerm.trim());
        } else if (searchTerm.length === 0) {
            handleSearch(null);
        }
    }, [searchTerm, handleSearch, onSubmit]);

    return (

        <Box width="100%">
            <Form
                onChange={(event) => setSearchTerm(event.search)}
                style={{ border: null }}
            >
                <FormField
                    name="search"
                    htmlFor="text-search-id"
                >
                    <Stack anchor="right">
                        <TextInput
                            id="text-search-id"
                            name="search"
                            icon={<Search />}
                            placeholder={intl.formatMessage({ id: 'search-text' })}
                            style={{ paddingLeft: '2rem', backgroundColor: 'white' }}
                            value={searchTerm}
                        />
                        {searchTerm.length > 0 && (
                            <StyledCloseButtom
                                onClick={handleClearSearch}
                                plain
                            />
                        )}
                    </Stack>
                </FormField>
            </Form>
        </Box>
    );
};

export default injectIntl(SearchField);
